// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/views/Dashboard/Botonera.css
// module id = ./src/views/Dashboard/Botonera.css
// module chunks = 0